import {
  CANCEL_REGISTRATION,
  REGISTER_USER_START,
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  SET_SUBMITTING,
  SUBMIT_EASY_JOIN_CODE_START,
  SUBMIT_EASY_JOIN_CODE_FULFILLED,
  SUBMIT_EASY_JOIN_CODE_REJECTED,
} from './actionTypes';

const initialState = {
  isComplete: false,
  isEasyJoinLoading: false,
  isRegistrationLoading: false,
  isSubmitting: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CANCEL_REGISTRATION: {
      return {
        ...state,
        isComplete: false,
        isEasyJoinLoading: false,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case REGISTER_USER_START: {
      return {
        ...state,
        isRegistrationLoading: true,
        isSubmitting: true,
      };
    }
    case REGISTER_USER_FULFILLED: {
      return {
        ...state,
        isComplete: true,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case REGISTER_USER_REJECTED: {
      return {
        ...state,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case SET_SUBMITTING: {
      return {
        ...state,
        isSubmitting: action.payload,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_START: {
      return {
        ...state,
        isEasyJoinLoading: true,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_FULFILLED: {
      return {
        ...state,
        isEasyJoinLoading: false,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_REJECTED: {
      return {
        ...state,
        isEasyJoinLoading: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
